import { useEffect, useState } from "react";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const links = [
    { href: "#about", label: "About" },
    { href: "#music", label: "Music" },
    { href: "#press", label: "Press" },
    { href: "#connect", label: "Connect" },
  ];

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-ivory/85 backdrop-blur-md border-b border-bone/60"
          : "bg-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-12 lg:px-20 h-16 md:h-20 flex items-center justify-between">
        <a
          data-testid="nav-logo"
          href="#top"
          aria-label="A Wider Horizon — home"
          className="w-8 h-8"
        >
          <span className="sr-only">A Wider Horizon</span>
        </a>
        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              href={l.href}
              className="text-[11px] uppercase tracking-[0.24em] text-ash hover:text-teal link-underline transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>
        <a
          data-testid="nav-listen-btn"
          href="https://open.spotify.com/track/49N5IoQvMo0nmwXZBUKvz0"
          target="_blank"
          rel="noopener noreferrer"
          className="hidden md:inline-flex items-center text-[11px] uppercase tracking-[0.24em] text-ivory bg-ink hover:bg-teal px-5 py-2.5 transition-colors"
        >
          Listen
        </a>
      </div>
    </header>
  );
}
